import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'

import { DndCustomContext, DndCustomContextType } from './dnd-custom-context.tsx'

export const DndCustomProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isDragging, setDndCustomProps] = useState<boolean>(false)
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  const setIsDragging = useCallback(
    (value: boolean) => {
      setDndCustomProps(value)
    },
    [setDndCustomProps]
  )

  const dndCustomProps: DndCustomContextType = {
    isDragging: isDragging,
    setIsDragging: setIsDragging,
    isTouchDevice: isTouchDevice,
  }

  useEffect(() => {
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    setIsTouchDevice(isTouch)
  }, [])

  const backend = isTouchDevice ? TouchBackend : HTML5Backend

  return (
    <DndCustomContext.Provider value={dndCustomProps}>
      <DndProvider backend={backend}>{children}</DndProvider>
    </DndCustomContext.Provider>
  )
}
